import { useState } from 'react';

/** Image avec légende: masquée si l'adresse est absente ou invalide, ou si l'image ne charge pas (restes d'exemples dans la base). */
export default function SafeImage({ src, alt, caption, className = 'w-full object-cover' }: { src?: string; alt: string; caption?: string; className?: string }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed || /placeholder\.com/i.test(src)) return null;
  return (
    <figure>
      <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} className={className} />
      {caption && <figcaption className="mt-3 text-sm text-ink">{caption}</figcaption>}
    </figure>
  );
}
